module.exports = "<div class=\"modal_wrapper\">\n    <div class=\"modal_overlay external\" ng-click=\"modal.close()\"></div>\n    <div class=\"modal external\">\n        <div class=\"modal__header\">\n            <h2>Additional Information</h2>\n            <button class=\"close\" ng-click=\"modal.close()\"></button>\n        </div>\n        <div class=\"modal__body\">\n            \n        <iframe ng-src=\"{{modal.link}}\" width=\"100%\" height=\"100%\"></iframe>\n        </div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modals/external/view.html
// module id = 97
// module chunks = 0